module.exports = __webpack_public_path__ + "static/media/AWS-SolArchitect-Pro.33991edb.png";